import React, {Fragment} from 'react';

export default function(){
    return(
        <Fragment>
            <h1>General</h1>
            <p>
               
            </p>
            <p>
              
            </p>
        </Fragment>
    )
}